module.exports = __webpack_public_path__ + "media/assets/images/flags/ao-babec7da6ec15be022ff636ccc94a0ae.svg";